var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckboxInverti = function SvgCheckboxInverti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 3.7h14c.7 0 1.3.6 1.3 1.3v14c0 .7-.6 1.3-1.3 1.3H5c-.7 0-1.3-.6-1.3-1.3V5c0-.7.6-1.3 1.3-1.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m6.7 12.4 3.2 2.9 7.4-6.7"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxInverti);
export default ForwardRef;